import { render, staticRenderFns } from "./eventos.vue?vue&type=template&id=530cc1f6&scoped=true"
import script from "./eventos.vue?vue&type=script&lang=js"
export * from "./eventos.vue?vue&type=script&lang=js"
import style0 from "./eventos.vue?vue&type=style&index=0&id=530cc1f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530cc1f6",
  null
  
)

/* custom blocks */
import block0 from "./eventos.vue?vue&type=custom&index=0&blockType=div&class=card%20mt-3%20shadow-sm%20border-light"
if (typeof block0 === 'function') block0(component)

export default component.exports